import TreatmentCategoryService from '../services/treatment-categories.service';
import { TreatmentCategory } from './models/models';

export default {
  namespaced: true,
  state: {
    treatmentCategoryId: null,
  },
  mutations: {
    treatmentCategoryId(state, treatmentCategoryId) {
      state.treatmentCategoryId = treatmentCategoryId;
    },
  },
  actions: {
    init({ dispatch }) {
      dispatch('getTreatmentCategories');
    },
    newTreatmentCategory({ commit }) {
      TreatmentCategory.new()
        .then((category) => {
          commit('treatmentCategoryId', category.id);
        });
    },
    updateTreatmentCategoryProps({ state }, props) {
      TreatmentCategory.update({
        where: state.treatmentCategoryId,
        data: props,
      });
    },
    getTreatmentCategories() {
      return TreatmentCategoryService.getTreatmentCategories()
        .then((res) => {
          TreatmentCategory.create({ data: res });
        });
    },
    suggestTreatmentCategories(store, query) {
      return TreatmentCategoryService.suggestTreatmentCategories(query);
    },
    getTreatmentCategory({ commit }, id) {
      return TreatmentCategoryService.getTreatmentCategory(id)
        .then((treatmentCategory) => {
          TreatmentCategory.insert({ data: [treatmentCategory] })
            .then(() => {
              commit('treatmentCategoryId', treatmentCategory.id);
            });
        });
    },
    createTreatmentCategory({ getters }) {
      return TreatmentCategoryService.createTreatmentCategory(getters.treatmentCategory);
    },
    updateTreatmentCategory({ getters, dispatch }) {
      return TreatmentCategoryService.updateTreatmentCategory(getters.treatmentCategory)
        .then((res) => {
          if (res.hasOwnProperty('treatment_category_id')) {
            dispatch('getTreatmentCategory', res.treatment_category_id);
          }
          return res;
        });
    },
    deleteTreatmentCategory({ getters }) {
      return TreatmentCategoryService.deleteTreatmentCategory(getters.treatmentCategory)
        .then((res) => {
          if (res.hasOwnProperty('treatment_category_id')) {
            TreatmentCategory.delete(res.treatment_category_id);
          }
          return res;
        });
    },
  },
  getters: {
    treatmentCategories() {
      return TreatmentCategory.all();
    },
    treatmentCategory(state) {
      if (!state.treatmentCategoryId) {
        return null;
      }
      return TreatmentCategory.query()
        .find(state.treatmentCategoryId);
    },
  },
};
